import { createReducer } from '@reduxjs/toolkit';
import { AsyncStatus, LogEntry } from 'lib-shared-legacy-types';

import { activityLogActions } from '../actions/activityLog';

export type ActivityLogState = {
  asyncStatus: AsyncStatus;
  entries: LogEntry[];
};

export const initialState: ActivityLogState = {
  asyncStatus: 'succeeded',
  entries: [],
};

export const activityLogReducer = createReducer<ActivityLogState>(
  initialState,
  (builder) => {
    builder
      .addCase(activityLogActions.get.pending, (state) => {
        state.asyncStatus = 'loading';
        state.entries = [];
      })
      .addCase(activityLogActions.get.fulfilled, (state, action) => {
        state.asyncStatus = 'succeeded';
        state.entries = action.payload.entries;
      })
      .addCase(activityLogActions.get.rejected, (state) => {
        state.asyncStatus = 'failed';
      });
  },
);
